const comTxtAnm = (() => {
  const comTxtAnmOuter = document.querySelectorAll('.js-com-txt-anm-outer');
  if (comTxtAnmOuter.length > 0) {



    let comTxtAnm = document.querySelectorAll('.js-com-txt-anm');

    for (let i = 0; i < comTxtAnm.length; i++) {

      function spanWrap() {
        const target = comTxtAnm[i];
        const nodes = [...target.childNodes];

        let spanWrapText = ""

        nodes.forEach((node) => {
          if (node.nodeType == 3) {//テキストの場合
            const text = node.textContent.replace(/\r?\n/g, '');//テキストから改行コード削除
            //spanで囲んで連結
            spanWrapText = spanWrapText + text.split('').reduce((acc, v) => {
              return acc + `<span>${v}</span>`
            }, "");
          } else {//テキスト以外
            //<br>などテキスト以外の要素をそのまま連結
            spanWrapText = spanWrapText + node.outerHTML
          }
        })

        target.innerHTML = spanWrapText
      }
      spanWrap();

    }



    let comTxtAnmOuter = document.querySelectorAll('.js-com-txt-anm-outer');

    comTxtAnmOuter.forEach((element, index) => {

      let spans = element.querySelectorAll('span');
      // console.log(spans)

      gsap.set(spans, {
        yPercent: 100,
        opacity: 0,
      });

      gsap.to(spans, {
        yPercent: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power1.out",
        scrollTrigger: {
          trigger: element,
          start: "0% 80%",
          // markers: true,
        },
        stagger: {
          each: 0.05,
        },
      });



    });



  }
})();
export default comTxtAnm;